module.exports = __webpack_public_path__ + "assets/images/amira_system_status_default.70f9847b7e980bc25146731e67646749.svg";